import { initEEBlobShow } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/blob/show/blob_show_bundle.js?vue3';

initEEBlobShow();
